import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../Users/redux/actions';
import Strings from '../../../Strings';

function OrgGroupForm(props) {
  const { match, getOrgGroupDetails, createOrgGroup, editOrgGroup, onNavigate } = props;
  const orgGroupId = match?.params?.orgGroupId;
  const isEditMode = orgGroupId && orgGroupId !== 'new';

  const [formData, setFormData] = React.useState({
    name: '',
    description: '',
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [validationErrors, setValidationErrors] = React.useState({});

  // Load org group data if editing
  React.useEffect(() => {
    if (isEditMode && getOrgGroupDetails) {
      setIsLoading(true);
      setError(null);

      getOrgGroupDetails(orgGroupId)
        .then(resp => {
          const data = resp?.response;
          if (data) {
            setFormData({
              name: data.name || '',
              description: data.description || '',
            });
          }
          setIsLoading(false);
        })
        .catch(err => {
          console.error('Failed to load org group:', err);
          setError('Failed to load org group');
          setIsLoading(false);
        });
    }
  }, [isEditMode, orgGroupId, getOrgGroupDetails]);

  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = Strings.nameRequired || 'Name is required';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    setValidationErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSaving(true);
    setError(null);

    try {
      const data = {
        name: formData.name,
      };

      if (formData.description.trim()) {
        data.description = formData.description;
      }

      if (isEditMode) {
        await editOrgGroup(orgGroupId, data);
      } else {
        await createOrgGroup(data);
      }

      onNavigate('/admin/org-groups');
    } catch (err) {
      console.error('Failed to save org group:', err);
      const errorMessage = err?.response?.data?.error_msg || 'Failed to save org group';
      setError(errorMessage);
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    onNavigate('/admin/org-groups');
  };

  if (isLoading) {
    return (
      <div className="org-group-form-page" style={{ padding: '20px' }}>
        <div className="loading">{Strings.loading || 'Loading...'}</div>
      </div>
    );
  }

  return (
    <div className="org-group-form-page" style={{ padding: '20px' }}>
      <div className="page-header" style={{ marginBottom: '20px' }}>
        <h1>{isEditMode ? (Strings.editOrgGroup || 'Edit Org Group') : (Strings.createOrgGroup || 'Create Org Group')}</h1>
      </div>

      <div className="form-container" style={{ maxWidth: '600px' }}>
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="error-message" style={{ color: 'red', marginBottom: '20px', padding: '10px', backgroundColor: '#ffebee', borderRadius: '4px' }}>
              <p>{error}</p>
            </div>
          )}

          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label htmlFor="name" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              {Strings.name || 'Name'} <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              disabled={isSaving}
              placeholder="Org group name"
              style={{ width: '100%', padding: '8px', border: validationErrors.name ? '1px solid red' : '1px solid #ccc', borderRadius: '4px' }}
            />
            {validationErrors.name && <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.name}</span>}
          </div>

          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label htmlFor="description" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              {Strings.description || 'Description'}
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              disabled={isSaving}
              rows={4}
              placeholder="Optional description"
              style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            />
          </div>

          <div className="form-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              className="btn-cancel"
              onClick={handleCancel}
              disabled={isSaving}
              style={{ padding: '10px 20px', cursor: 'pointer', backgroundColor: '#f5f5f5', border: '1px solid #ccc', borderRadius: '4px' }}
            >
              {Strings.cancel || 'Cancel'}
            </button>
            <button
              type="submit"
              className="btn-submit"
              disabled={isSaving}
              style={{ padding: '10px 20px', cursor: 'pointer', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px' }}
            >
              {isSaving ? (Strings.saving || 'Saving...') : (isEditMode ? (Strings.update || 'Update') : (Strings.create || 'Create'))}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  getOrgGroupDetails: orgGroupId => dispatch(actions.getOrgGroupDetails(orgGroupId)),
  createOrgGroup: data => dispatch(actions.createOrgGroup(data)),
  editOrgGroup: (orgGroupId, data) => dispatch(actions.editOrgGroup(orgGroupId, data)),
  onNavigate: path => dispatch(push(path)),
});

export default connect(null, mapDispatchToProps)(OrgGroupForm);
